import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import Hero from "./components/Hero";
import Banner from "./components/Banner";
import Services from "./components/Services";
import WhyUs from "./components/WhyUs";
import Symptoms from "./components/Symptoms";
import Zones from "./components/Zones";
import GoogleReviews from "@/components/feature/GoogleReviews";
import ContactForm from "./components/ContactForm";
import PiecesSection from "@/components/feature/PiecesSection";
import ServicesSection from "@/components/feature/ServicesSection";
import { defaultPieces, defaultServices } from "@/mocks/servicesSections";
import VideoDiagnostic from "@/components/feature/VideoDiagnostic";
import FloatingButton from "./components/FloatingButton";

export default function Home() {
  useSEO(seoData.home);
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <VideoDiagnostic />
        <PiecesSection {...defaultPieces} />
        <ServicesSection {...defaultServices} />
        <Banner />
        <Services />
        <WhyUs />
        <Symptoms />
        <Zones />
        <GoogleReviews />
        <ContactForm />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}